<template>
  <main class="p-passwordchangecomplete">
    <section class="p-passwordchangecomplete__wrap">
      <h2 class="c-regist__title">{{ t('PasswordChangeCompletePage.title') }}</h2>
      <RegisterFlow :steps="4" :nowStep="4" />
      <p class="c-regist__comment">
        {{ t('PasswordChangeCompletePage.message.first') }}
      </p>
      <div class="p-passwordchangecomplete__line-link">
        <a class="c-button" :href="fluxLoginUrl">
          <span class="c-button__text">{{ t('PasswordChangeCompletePage.login') }}</span>
        </a>
      </div>
    </section>
  </main>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import RegisterFlow from '@/components/registerTeam/RegisterFlow.vue'
import useValidateForAccess from '@/Hooks/useValidateForAccess'
import AppInfo from '@/util/AppInfo'

export default defineComponent({
  name: 'PasswordChangeCompletePage',
  setup() {
    const { t } = useI18n()
    onMounted(() => {
      useValidateForAccess('PasswordChangeStore', ['tokenId'], 'ErrorPage')
    })
    const fluxLoginUrl = computed(() => {
      if (AppInfo.isSmartPhone) {
        return `${process.env.VUE_APP_FLUX_LOGIN_PAGE_BASE_URL}/flsp/index.html#/login`
      }
      return `${process.env.VUE_APP_FLUX_LOGIN_PAGE_BASE_URL}/fl/index.html#/login`
    })
    return {
      fluxLoginUrl,
      t,
    }
  },
  components: {
    RegisterFlow,
  },
})
</script>

<style scoped lang="scss"></style>
